import client from "../client";

export interface CancelDepositRequest {
  transaction_id: number;
  note?: string;
}

export interface CancelDepositResponse {
  success?: boolean;
  message?: string;
  transaction_id?: string;
  status?: string;
}

export default function API(
  request: CancelDepositRequest
): Promise<CancelDepositResponse> {
  return client
    .post(`payment_v2/deposit/cancel`, request)
    .then((response) => response.data);
}
